<script>


import { totalScore } from './stores.js';
import { bpScore } from './stores.js';
import { pulseScore } from './stores.js';
import { tempScore } from './stores.js';
import { respScore } from './stores.js';
import { satScore } from './stores.js';

 export let Pulse;
 export let BP;
 export let Temp;
 export let Resp;
 export let Sat;

$: totalScore.update(value => {
    value = Math.abs(Pulse) + Math.abs(BP) + Math.abs(Temp) + Math.abs(Resp) + Math.abs(Sat);
    return value;
});
$: pulseScore.update(value => {
    value = Math.abs(Pulse);
    return value;
});
$: bpScore.update(value => {
    value = Math.abs(BP);
    return value;
});
$: tempScore.update(value => {
    value = Math.abs(Temp);
    return value;
});
$: respScore.update(value => {
    value = Math.abs(Resp);
    return value;
});
$: satScore.update(value => {
    value = Math.abs(Sat);
    return value;
});

</script>

<style>
 h1 {
    padding: 15px; 
    text-align: center;
     margin-bottom: 0px;
 }

 p {
     text-align: center;
     margin: 0px;
 }

 h3 {
     text-align: center;
 }
 .yellow {
    color: rgb(181, 181, 15);
 }
 .orange {
	color: rgb(239, 135, 9);
}

.red {
	color: rgb(126, 5, 5);
}
</style>
   <div>
        {#if $totalScore > 6}
            <div>
            <h1 class="red">TOTAL SCORE = {$totalScore}</h1>
            <p>High Severity</p>
                {#if $bpScore == 3 || $pulseScore == 3 || $tempScore == 3 || $respScore == 3 || $satScore == 3 }
                        {#if $bpScore ===3}
                        <h3 class="orange">Blood Pressure Alert</h3>
                        {/if}
                        {#if $pulseScore ==3}
                        <h3 class="orange">Pulse Alert</h3>
                        {/if}
                        {#if $respScore ==3}
                        <h3 class="orange">Respiratory Rate Alert</h3>
                        {/if}
                        {#if $tempScore ==3}
                        <h3 class="orange">Low Temperature Alert</h3>
                        {/if}
                        {#if $satScore ==3}
                        <h3 class="orange">O2 Saturation Alert</h3>
                        {/if}
                {/if}
            </div>        
        {:else if $bpScore == 3 || $pulseScore == 3 || $tempScore == 3 || $respScore == 3 || $satScore == 3 }
            <div>
                <h1 class="orange">TOTAL SCORE = {$totalScore}</h1>
                <p>An individual vital sign has moderate severity</p>
                    {#if $bpScore ===3}
                    <h3 class="orange">Blood Pressure Alert</h3>
                    {/if}
                    {#if $pulseScore ==3}
                    <h3 class="orange">Pulse Alert</h3>
                    {/if}
                    {#if $respScore ==3}
                    <h3 class="orange">Respiratory Rate Alert</h3>
                    {/if}
                    {#if $tempScore ==3}
                    <h3 class="orange">Low Temperature Alert</h3>
                    {/if}
                    {#if $satScore ==3}
                    <h3 class="orange">O2 Saturation Alert</h3>
                    {/if}
            </div>    
        {:else if $totalScore > 4}
            <div>
            <h1 class="orange">TOTAL SCORE = {$totalScore}</h1>
            <p>Moderate Severity
            </div>
        {:else}
            <div>
            <h1> TOTAL SCORE = {$totalScore}</h1>
            <p>Low Severity</p>
            </div>
        {/if}
    
    
        {#if (Pulse >=1 && Resp >=2 && $tempScore >=1 || Pulse >= 1 && (Resp >=2 || $tempScore >=1) || Resp >=2 && (Pulse >=1 || $tempScore>=1) || $tempScore>=1 && (Pulse >=1 || Resp >=2)) }
        <div>
        <h3 class="yellow">SIRS/Sepsis: Consider further evaluation for potential sepsis if infection is suspected.</h3>
        </div>
        {/if}
    </div>

